import React from 'react';
import { connect } from 'react-redux';
import { 
  instanceEatdTestOperatorAdd, instanceEatdTestOperatorRemove, instanceEatdAnonymizeOperator,
  instanceEatdTestPreviewAnonymization, instanceEatdCountMatchingOperators, instanceEatdTestIncidentAdd, instanceEatdTestIncidentRemove,
  instanceEatdApplyChangesToIncident, instanceEatdPreviewChangesForIncident, instanceEatdCountMatchingIncidents,
  instanceEatdTestPersonAdd, instanceEatdTestPersonRemove, instanceEatdApplyChangesToPerson, instanceEatdCountMatchingPersons,
  instanceEatdPreviewChangesForPerson,
  instanceEatdTestChangeAdd, instanceEatdTestChangeRemove, instanceEatdApplyChangesToChange,
  instanceEatdPreviewChangesForChange, instanceEatdCountMatchingChanges,
} from 'client/redux/eatd/testActions';
import _ from 'lodash';
import InstanceHelpHeader from 'client/components/Instance/components/InstanceHelpHeader';
import BeRemoteErrorAlert from 'client/components/Be/BeRemoteErrorAlert';
import BeLoading from 'client/components/Be/BeLoading';
import EATDTesterAddTopdeskOperator from 'client/components/EATD/EATDTesterAddTopdeskOperator';
import EATDTesterOperator from 'client/components/EATD/EATDTesterOperator';
import EATDTesterAddTopdeskIncident from 'client/components/EATD/EATDTesterAddTopdeskIncident';
import EATDTesterIncident from 'client/components/EATD/EATDTesterIncident';
import EATDTesterAddTopdeskPerson from 'client/components/EATD/EATDTesterAddTopdeskPerson';
import EATDTesterPerson from 'client/components/EATD/EATDTesterPerson';
import EATDTesterAddTopdeskChange from 'client/components/EATD/EATDTesterAddTopdeskChange';
import EATDTesterChange from 'client/components/EATD/EATDTesterChange';
import PropTypes from 'prop-types';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';
import { getEatdActiveTab, setEatdActiveTab } from 'client/components/EATD/tabState';

class EATDTester extends React.Component {
  state = {
    activeTab: 'operator',
    topdeskOperatorId: '',
    topdeskIncidentId: '',
    topdeskPersonId: '',
    topdeskChangeId: '',
  };

  constructor (props) {
    super(props);
    this.toggleTab = this.toggleTab.bind(this);
    this.onChangeTopdeskOperatorId = this.onChangeTopdeskOperatorId.bind(this);
    this.onClickAddTopdeskOperator = this.onClickAddTopdeskOperator.bind(this);
    this.onClickRemoveTopdeskOperator = this.onClickRemoveTopdeskOperator.bind(this);
    this.onClickAnonymizeTopdeskOperator = this.onClickAnonymizeTopdeskOperator.bind(this);
    this.onClickPreviewAnonymization = this.onClickPreviewAnonymization.bind(this);
    this.handleCountMatchingOperators = this.handleCountMatchingOperators.bind(this);
    this.onChangeTopdeskIncidentId = this.onChangeTopdeskIncidentId.bind(this);
    this.handleAddIncident = this.handleAddIncident.bind(this);
    this.handleRemoveIncident = this.handleRemoveIncident.bind(this);
    this.handleIncidentApplyChanges = this.handleIncidentApplyChanges.bind(this);
    this.handleIncidentPreviewChanges = this.handleIncidentPreviewChanges.bind(this);
    this.handleCountMatchingIncidents = this.handleCountMatchingIncidents.bind(this);
    this.onChangeTopdeskPersonId = this.onChangeTopdeskPersonId.bind(this);
    this.handleAddPerson = this.handleAddPerson.bind(this);
    this.handleRemovePerson = this.handleRemovePerson.bind(this);
    this.handlePersonApplyChanges = this.handlePersonApplyChanges.bind(this);
    this.handlePersonPreviewChanges = this.handlePersonPreviewChanges.bind(this);
    this.handleCountMatchingPersons = this.handleCountMatchingPersons.bind(this);
    this.onChangeTopdeskChangeId = this.onChangeTopdeskChangeId.bind(this);
    this.handleAddChange = this.handleAddChange.bind(this);
    this.handleRemoveChange = this.handleRemoveChange.bind(this);
    this.handleChangeApplyChanges = this.handleChangeApplyChanges.bind(this);
    this.handleChangePreviewChanges = this.handleChangePreviewChanges.bind(this);
    this.handleCountMatchingChanges = this.handleCountMatchingChanges.bind(this);
  }

  componentDidMount () {
    const instanceId = this.instanceId();
    if (!instanceId) return;
    const activeTab = getEatdActiveTab(instanceId);
    if (activeTab !== this.state.activeTab) {
      this.setState({ activeTab });
    }
  }

  instanceId () {
    return _.get(this.props, 'instance.id');
  }

  toggleTab (tab) {
    if (this.state.activeTab !== tab) {
      setEatdActiveTab(this.instanceId(), tab);
      this.setState({ activeTab: tab });
    }
  }

  onClickAddTopdeskOperator = () => {
    const { topdeskOperatorId } = this.state;
    const instanceId = this.instanceId();
    if (!topdeskOperatorId || !instanceId) return;
    this.props.instanceEatdTestOperatorAdd(instanceId, topdeskOperatorId).then(() => {
      this.setState({ topdeskOperatorId: '' });
    })
      .catch(error => {
      
      });
  };

  onClickRemoveTopdeskOperator = topdeskOperatorId => {
    if (window.confirm(`Are you sure you want to remove Operator ${topdeskOperatorId} from the test list?`)) {
      return this.props.instanceEatdTestOperatorRemove(topdeskOperatorId);
    }
    return Promise.resolve();
  };

  onClickAnonymizeTopdeskOperator = topdeskOperatorId => {
    return this.props.instanceEatdAnonymizeOperator(this.instanceId(), topdeskOperatorId);
  };

  onClickPreviewAnonymization = topdeskOperatorId => {
    return this.props.instanceEatdTestPreviewAnonymization(this.instanceId(), topdeskOperatorId);
  };

  handleCountMatchingOperators = () => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId) return undefined;

    return this.props.instanceEatdCountMatchingOperators(currentInstanceId)
      .catch(() => {
      });
  };

  onChangeTopdeskOperatorId = topdeskOperatorId => {
    this.setState({ topdeskOperatorId });
  };

  onChangeTopdeskIncidentId = topdeskIncidentId => {
    this.setState({ topdeskIncidentId });
  };

  handleAddIncident = (incidentId) => {
    const instanceId = this.instanceId();
    
    
    if (!instanceId) {
      
      return Promise.reject(new Error('Missing instanceId'));
    }
    
    if (!incidentId) {
      
      return Promise.reject(new Error('Missing incidentId'));
    }
    
    if (this.props.testIncidents && this.props.testIncidents[incidentId]) {
      
      return Promise.resolve();
    }
    
    
    
    return this.props.instanceEatdTestIncidentAdd(instanceId, incidentId)
      .then(result => {
        this.setState({ topdeskIncidentId: '' });
        return result;
      })
      .catch(error => {
        
        throw error;
      });
  };

  handleRemoveIncident = (incidentId) => {
    
    this.props.instanceEatdTestIncidentRemove(incidentId);
  };

  handleIncidentApplyChanges = (incidentId) => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId || !incidentId) return;

    
    this.props.instanceEatdApplyChangesToIncident(currentInstanceId, incidentId)
      .catch(error => {
            
      });
  };

  handleIncidentPreviewChanges = (incidentId) => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId || !incidentId) return;

    
    this.props.instanceEatdPreviewChangesForIncident(currentInstanceId, incidentId)
      .catch(error => {
            
      });
  };

  /**
   * @description Fetches the current number of incidents that match live processing conditions.
   *              This includes both profile eligibility and when/then rule matching.
   * @returns {Promise<void>|undefined}
   */
  handleCountMatchingIncidents = () => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId) return undefined;

    return this.props.instanceEatdCountMatchingIncidents(currentInstanceId)
      .catch(() => {
      });
  };

  handleAddPerson = (personId) => {
    const instanceId = this.instanceId();
    if (!instanceId || !personId || this.props.testPersons?.[personId]) {
      return Promise.resolve();
    }
    
    return this.props.instanceEatdTestPersonAdd(instanceId, personId)
      .then(result => {
        this.setState({ topdeskPersonId: '' });
        return result;
      })
      .catch(error => {
        throw error;
      });
  };

  handleRemovePerson = (personId) => {
    
    if (window.confirm(`Are you sure you want to remove Person ${personId} from the test list?`)) {
      this.props.instanceEatdTestPersonRemove(personId); // Dispatch remove action
    }
  };

  handlePersonApplyChanges = (personId) => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId || !personId) return;

    
    this.props.instanceEatdApplyChangesToPerson(currentInstanceId, personId)
      .catch(error => {
            
      });
  };

  handlePersonPreviewChanges = (personId) => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId || !personId) return;

    
    this.props.instanceEatdPreviewChangesForPerson(currentInstanceId, personId)
      .catch(error => {
            
      });
  };

  handleCountMatchingPersons = () => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId) return undefined;

    return this.props.instanceEatdCountMatchingPersons(currentInstanceId)
      .catch(() => {
      });
  };

  onChangeTopdeskPersonId = topdeskPersonId => {
    this.setState({ topdeskPersonId });
  };

  handleAddChange = (changeId) => {
    const instanceId = this.instanceId();
    if (!instanceId || !changeId || this.props.testChanges?.[changeId]) {
      return Promise.resolve();
    }

    return this.props.instanceEatdTestChangeAdd(instanceId, changeId)
      .then(result => {
        this.setState({ topdeskChangeId: '' });
        return result;
      })
      .catch(error => {
        throw error;
      });
  };

  onChangeTopdeskChangeId = topdeskChangeId => {
    this.setState({ topdeskChangeId });
  };

  handleRemoveChange = (changeId) => {
    if (window.confirm(`Are you sure you want to remove Change ${changeId} from the test list?`)) {
      this.props.instanceEatdTestChangeRemove(changeId);
    }
  };

  handleChangeApplyChanges = (changeId) => {
    const instanceId = this.instanceId();
    if (!instanceId || !changeId) return;

    this.props.instanceEatdApplyChangesToChange(instanceId, changeId)
      .catch(() => {
      });
  };

  handleChangePreviewChanges = (changeId) => {
    const instanceId = this.instanceId();
    if (!instanceId || !changeId) return;

    this.props.instanceEatdPreviewChangesForChange(instanceId, changeId)
      .catch(() => {
      });
  };

  handleCountMatchingChanges = () => {
    const currentInstanceId = this.instanceId();
    if (!currentInstanceId) return undefined;

    return this.props.instanceEatdCountMatchingChanges(currentInstanceId)
      .catch(() => {
      });
  };

  render () {
    const {
      activeTab,
      topdeskOperatorId,
      topdeskIncidentId,
      topdeskPersonId,
      topdeskChangeId,
    } = this.state;
    const {
      endpointsByType,
      isInstanceLoading,
      error,
      topdeskOperators,
      isAddingOperator,
      isAddingIncident,
      isAddingPerson,
      isAddingChange,
      isCountingOperatorMatches,
      addIncidentError,
      addPersonError,
      addChangeError,
      operatorMatchCount,
      operatorMatchCountError,
      incidentMatchCount,
      incidentMatchCountError,
      isCountingIncidentMatches,
      isCountingPersonMatches,
      personMatchCount,
      personMatchCountError,
      isCountingChangeMatches,
      changeMatchCount,
      changeMatchCountError,
      testIncidents,
      testPersons,
      testChanges,
    } = this.props;

    if (isInstanceLoading) {
      return <BeLoading>Loading instance data...</BeLoading>;
    }

    // Derive endpointId from prop, accounting for array structure from /view endpoint
    const topdeskEndpoint = Array.isArray(endpointsByType?.topdesk) ? endpointsByType.topdesk[0] : endpointsByType?.topdesk;
    const topdeskEndpointId = topdeskEndpoint?.id;

    

    const canAdd = !!topdeskEndpointId;
    const missingEndpointWarning = (
      <div className="alert alert-warning">
            TOPdesk endpoint configuration is missing or not loaded. Cannot add items.
      </div>
    );

    // Simple styles for active/inactive tabs - can be moved to CSS
    const tabButtonStyle = {
      padding: '10px 15px',
      marginRight: '5px',
      border: '1px solid #ccc',
      borderBottom: 'none',
      cursor: 'pointer',
      background: '#eee',
    };
    const activeTabButtonStyle = {
      ...tabButtonStyle,
      background: '#fff',
      borderBottom: '1px solid #fff',
      marginTop: '-1px',
      position: 'relative',
      zIndex: 1,
    };

    return (
      <div>
        {/* --- Tab Navigation (using buttons) --- */}
        <div style={{ borderBottom: '1px solid #ccc', marginBottom: '15px' }}>
          <button
            type="button"
            style={activeTab === 'operator' ? activeTabButtonStyle : tabButtonStyle}
            onClick={() => {
              this.toggleTab('operator'); 
            }}
            disabled={activeTab === 'operator'}
          >
                Operator Anonymization Test
          </button>
          <button
            type="button"
            style={activeTab === 'incident' ? activeTabButtonStyle : tabButtonStyle}
            onClick={() => {
              this.toggleTab('incident'); 
            }}
            disabled={activeTab === 'incident'}
          >
                Incident Anonymization Test
          </button>
          <button
            type="button"
            style={activeTab === 'person' ? activeTabButtonStyle : tabButtonStyle}
            onClick={() => {
              this.toggleTab('person'); 
            }}
            disabled={activeTab === 'person'}
          >
                Person Anonymization Test
          </button>
          <button
            type="button"
            style={activeTab === 'change' ? activeTabButtonStyle : tabButtonStyle}
            onClick={() => {
              this.toggleTab('change'); 
            }}
            disabled={activeTab === 'change'}
          >
                Change Anonymization Test
          </button>
        </div>

        {/* Display general errors */} 
        <BeRemoteErrorAlert error={activeTab === 'operator' ? error : null} />

        {/* --- Tab Content (using conditional rendering) --- */}
        <div>
          {/* --- Operator Test Content --- */} 
          {activeTab === 'operator' && (
            <div>
              <InstanceHelpHeader helpFragmentId="instance_eatd_test_help" subTitle="Add operators to test anonymization rules">
                        Test Operator Anonymization
              </InstanceHelpHeader>

              <div role="alert" className="alert alert-warning alert-icon mb-3">
                <div className="icon"><span className="mdi mdi-alert-circle-outline"></span></div>
                <div className="message">
                  <strong>Warning:</strong> Clicking "Anonymize" on an added operator below will permanently anonymize their data in TOPdesk according to the rules defined in the settings.
                </div>
              </div>

              <div className="mb-3">
                <ButtonWaiting
                  type="button"
                  className="btn btn-rounded btn-info"
                  onClick={this.handleCountMatchingOperators}
                  isWaiting={isCountingOperatorMatches}
                  disabled={isCountingOperatorMatches}
                  title="Count operators that currently match anonymization conditions"
                >
                  <i className="icon icon-left mdi mdi-counter"></i>
                  Count Matching Operators
                </ButtonWaiting>
              </div>

              <BeRemoteErrorAlert error={operatorMatchCountError} />

              {operatorMatchCount !== null && !operatorMatchCountError && (
                <div className="alert alert-info mb-3">
                  {operatorMatchCount === 1
                    ? '1 operator matches the current anonymization conditions.'
                    : `${operatorMatchCount} operators match the current anonymization conditions.`}
                </div>
              )}

              <h4>TOPdesk Operators for Testing</h4>
              <div className="list-group mb-3">
                {Object.keys(topdeskOperators || {}).length > 0 ? (
                  _.map(topdeskOperators, (operator, id) => (
                    <EATDTesterOperator
                      key={id}
                      operator={operator}
                      onRemove={() => this.onClickRemoveTopdeskOperator(operator.id || id)}
                      onAnonymize={() => this.onClickAnonymizeTopdeskOperator(operator.id || id)}
                      onPreviewAnonymization={() => this.onClickPreviewAnonymization(operator.id || id)}
                    />
                  ))
                ) : (
                  <div className="list-group-item">
                         "No TOPdesk Operators added for testing."
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-6 offset-md-6">
                  {canAdd ? (
                    <EATDTesterAddTopdeskOperator
                      endpointId={topdeskEndpointId}
                      objectId={topdeskOperatorId}
                      onChange={this.onChangeTopdeskOperatorId}
                      onAdd={this.onClickAddTopdeskOperator}
                      isAdding={isAddingOperator}
                    />
                  ) : (
                    missingEndpointWarning
                  )}
                </div>
              </div>
            </div>
          )}

          {/* --- Incident Test Content --- */} 
          {activeTab === 'incident' && (
            <div>
              <InstanceHelpHeader helpFragmentId="instance_eatd_incident_test_help" subTitle="Add Incidents to test anonymization rules">
                         Test Incident Anonymization
              </InstanceHelpHeader>

              <div role="alert" className="alert alert-warning alert-icon mb-3">
                <div className="icon"><span className="mdi mdi-alert-circle-outline"></span></div>
                <div className="message">
                  <strong>Warning:</strong> Clicking "Apply Changes" below may modify the specified incident's data in TOPdesk according to the rules defined in the settings.
                </div>
              </div>

              <div className="mb-3">
                <ButtonWaiting
                  type="button"
                  className="btn btn-rounded btn-info"
                  onClick={this.handleCountMatchingIncidents}
                  isWaiting={isCountingIncidentMatches}
                  disabled={isCountingIncidentMatches}
                  title="Count incidents that currently match anonymization conditions"
                >
                  <i className="icon icon-left mdi mdi-counter"></i>
                  Count Incidents To Anonymize
                </ButtonWaiting>
              </div>

              <BeRemoteErrorAlert error={incidentMatchCountError} />

              {incidentMatchCount !== null && !incidentMatchCountError && (
                <div className="alert alert-info mb-3">
                  {incidentMatchCount === 1
                    ? '1 incident would currently be anonymized.'
                    : `${incidentMatchCount} incidents would currently be anonymized.`}
                </div>
              )}

              {/* Render the List of Incident Test Items */} 
              <h4>TOPdesk Incidents for Testing</h4>
              <div className="list-group mb-3">
                {Object.keys(testIncidents || {}).length > 0 ? (
                  Object.entries(testIncidents).map(([id, state]) => {
                    const isApplying = state?.isApplying || false;
                    const isPreviewing = state?.isPreviewing || false;
                    const isLoading = isApplying || isPreviewing;
                    const error = state?.error || null;
                    const applyResult = state?.applyResult || null;
                    const previewResult = state?.previewResult || null;

                                

                    return (
                      <EATDTesterIncident
                        key={id}
                        incidentId={id}
                        incidentNumber={state?.number || state?.previewResult?.data?.original?.number}
                        onRemove={this.handleRemoveIncident}
                        onApplyChanges={this.handleIncidentApplyChanges}
                        onPreviewChanges={this.handleIncidentPreviewChanges}
                        previewResult={previewResult}
                        isPreviewing={isPreviewing}
                        isApplying={isApplying}
                        isLoading={isLoading}
                        error={error}
                        applyResult={applyResult}
                      />
                    );
                  })
                ) : (
                  <div className="list-group-item">
                                No TOPdesk Incidents added for testing.
                  </div>
                )}
              </div>

              {/* Render the Incident Adder Component */} 
              <div className="row">
                <div className="col-md-6 offset-md-6">
                  {canAdd ? (
                    <>
                      <EATDTesterAddTopdeskIncident
                        endpointId={topdeskEndpointId}
                        objectId={topdeskIncidentId}
                        onChange={this.onChangeTopdeskIncidentId}
                        onAdd={this.handleAddIncident}
                        isAdding={isAddingIncident}
                      />
                      <BeRemoteErrorAlert error={addIncidentError} />
                    </>
                  ) : (
                    missingEndpointWarning
                  )}
                </div>
              </div>

            </div>
          )}

          {/* --- Person Test Content --- */}
          {activeTab === 'person' && (
            <div>
              <InstanceHelpHeader helpFragmentId="instance_eatd_person_test_help" subTitle="Add Persons to test anonymization rules">
                        Test Person Anonymization
              </InstanceHelpHeader>

              <div role="alert" className="alert alert-warning alert-icon mb-3">
                <div className="icon"><span className="mdi mdi-alert-circle-outline"></span></div>
                <div className="message">
                  <strong>Warning:</strong> Clicking "Apply Changes" below may modify the specified person's data in TOPdesk according to the rules defined in the settings.
                </div>
              </div>

              <div className="mb-3">
                <ButtonWaiting
                  type="button"
                  className="btn btn-rounded btn-info"
                  onClick={this.handleCountMatchingPersons}
                  isWaiting={isCountingPersonMatches}
                  disabled={isCountingPersonMatches}
                  title="Count persons that currently match anonymization conditions"
                >
                  <i className="icon icon-left mdi mdi-counter"></i>
                  Count Persons To Anonymize
                </ButtonWaiting>
              </div>

              <BeRemoteErrorAlert error={personMatchCountError} />

              {personMatchCount !== null && !personMatchCountError && (
                <div className="alert alert-info mb-3">
                  {personMatchCount === 1
                    ? '1 person would currently be anonymized.'
                    : `${personMatchCount} persons would currently be anonymized.`}
                </div>
              )}

              {/* Render the List of Person Test Items */} 
              <h4>TOPdesk Persons for Testing</h4>
              <div className="list-group mb-3">
                {Object.keys(testPersons || {}).length > 0 ? (
                  Object.entries(testPersons).map(([id, state]) => {
                    // Extract state for the specific person (adjust keys based on Redux structure)
                    const personName = state?.name || state?.previewResult?.data?.originalData?.dynamicName || id;
                    const isApplying = state?.isApplying || false;
                    const isPreviewing = state?.isPreviewing || false;
                    const itemError = state?.error || null; // Use a different name to avoid conflict with general error prop
                    const applyResult = state?.applyResult || null;
                    const previewResult = state?.previewResult || null;

                                

                    return (
                      <EATDTesterPerson
                        key={id}
                        personId={id}
                        personName={personName}
                        onRemove={this.handleRemovePerson}
                        onApplyChanges={this.handlePersonApplyChanges}
                        onPreviewChanges={this.handlePersonPreviewChanges}
                        previewResult={previewResult}
                        isPreviewing={isPreviewing}
                        isApplying={isApplying}
                        error={itemError} // Pass the specific item's error
                        applyResult={applyResult}
                      />
                    );
                  })
                ) : (
                  <div className="list-group-item">
                                No TOPdesk Persons added for testing.
                  </div>
                )}
              </div>

              {/* Render the Person Adder Component */} 
              <div className="row">
                <div className="col-md-6 offset-md-6">
                  {canAdd ? (
                    <>
                      <EATDTesterAddTopdeskPerson
                        endpointId={topdeskEndpointId}
                        objectId={topdeskPersonId}
                        onChange={this.onChangeTopdeskPersonId}
                        onAdd={this.handleAddPerson}
                        isAdding={isAddingPerson}
                      />
                      <BeRemoteErrorAlert error={addPersonError} />
                    </>
                  ) : (
                    missingEndpointWarning
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'change' && (
            <div>
              <InstanceHelpHeader helpFragmentId="instance_eatd_change_test_help" subTitle="Add Changes to test anonymization rules">
                        Test Change Anonymization
              </InstanceHelpHeader>

              <div role="alert" className="alert alert-warning alert-icon mb-3">
                <div className="icon"><span className="mdi mdi-alert-circle-outline"></span></div>
                <div className="message">
                  <strong>Warning:</strong> Clicking "Apply Changes" below may modify the specified TOPdesk change according to the rules defined in the settings.
                </div>
              </div>

              <div className="mb-3">
                <ButtonWaiting
                  type="button"
                  className="btn btn-rounded btn-info"
                  onClick={this.handleCountMatchingChanges}
                  isWaiting={isCountingChangeMatches}
                  disabled={isCountingChangeMatches}
                  title="Count changes that currently match anonymization conditions"
                >
                  <i className="icon icon-left mdi mdi-counter"></i>
                  Count Changes To Anonymize
                </ButtonWaiting>
              </div>

              <BeRemoteErrorAlert error={changeMatchCountError} />

              {changeMatchCount !== null && !changeMatchCountError && (
                <div className="alert alert-info mb-3">
                  {changeMatchCount === 1
                    ? '1 change would currently be anonymized.'
                    : `${changeMatchCount} changes would currently be anonymized.`}
                </div>
              )}

              <h4>TOPdesk Changes for Testing</h4>
              <div className="list-group mb-3">
                {Object.keys(testChanges || {}).length > 0 ? (
                  Object.entries(testChanges).map(([id, state]) => (
                    <EATDTesterChange
                      key={id}
                      changeId={id}
                      changeNumber={state?.number || state?.previewResult?.data?.originalData?.number}
                      onRemove={this.handleRemoveChange}
                      onApplyChanges={this.handleChangeApplyChanges}
                      onPreviewChanges={this.handleChangePreviewChanges}
                      previewResult={state?.previewResult || null}
                      isPreviewing={state?.isPreviewing || false}
                      isApplying={state?.isApplying || false}
                      error={state?.error || null}
                      applyResult={state?.applyResult || null}
                    />
                  ))
                ) : (
                  <div className="list-group-item">
                                No TOPdesk Changes added for testing.
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-6 offset-md-6">
                  {canAdd ? (
                    <>
                      <EATDTesterAddTopdeskChange
                        endpointId={topdeskEndpointId}
                        objectId={topdeskChangeId}
                        onChange={this.onChangeTopdeskChangeId}
                        onAdd={this.handleAddChange}
                        isAdding={isAddingChange}
                      />
                      <BeRemoteErrorAlert error={addChangeError} />
                    </>
                  ) : (
                    missingEndpointWarning
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // Log the props received directly from the parent (InstanceDashboard)
  
  
  return {
    // Reads instance and endpoints from props passed by parent (InstanceDashboard)
    instance: ownProps.instance,
    endpointsByType: ownProps.endpointsByType, // Still selecting from ownProps here
    isInstanceLoading: ownProps.isInstanceLoading,
    // Reads EATD-specific test state from eatd.test slice
    testIncidents: state.eatd.test.testIncidents || {},
    error: state.eatd.test.error,
    topdeskOperators: state.eatd.test.topdeskOperators || {},
    isAddingOperator: state.eatd.test.isAddingOperator,
    isCountingOperatorMatches: state.eatd.test.isCountingOperatorMatches || false,
    isAddingIncident: state.eatd.test.isAddingIncident || false,
    isAddingPerson: state.eatd.test.isAddingPerson || false,
    isAddingChange: state.eatd.test.isAddingChange || false,
    isCountingIncidentMatches: state.eatd.test.isCountingIncidentMatches || false,
    addIncidentError: state.eatd.test.addIncidentError,
    addPersonError: state.eatd.test.addPersonError,
    addChangeError: state.eatd.test.addChangeError,
    operatorMatchCount: state.eatd.test.operatorMatchCount,
    operatorMatchCountError: state.eatd.test.operatorMatchCountError,
    incidentMatchCount: state.eatd.test.incidentMatchCount,
    incidentMatchCountError: state.eatd.test.incidentMatchCountError,
    isCountingPersonMatches: state.eatd.test.isCountingPersonMatches || false,
    personMatchCount: state.eatd.test.personMatchCount,
    personMatchCountError: state.eatd.test.personMatchCountError,
    isCountingChangeMatches: state.eatd.test.isCountingChangeMatches || false,
    changeMatchCount: state.eatd.test.changeMatchCount,
    changeMatchCountError: state.eatd.test.changeMatchCountError,
    testPersons: state.eatd.test.testPersons || {},
    testChanges: state.eatd.test.testChanges || {},
  };
};

const mapDispatchToProps = {
  instanceEatdTestOperatorAdd,
  instanceEatdTestOperatorRemove,
  instanceEatdAnonymizeOperator,
  instanceEatdTestPreviewAnonymization,
  instanceEatdCountMatchingOperators,
  instanceEatdTestIncidentAdd,
  instanceEatdTestIncidentRemove,
  instanceEatdApplyChangesToIncident,
  instanceEatdPreviewChangesForIncident,
  instanceEatdCountMatchingIncidents,
  instanceEatdTestPersonAdd,
  instanceEatdTestPersonRemove,
  instanceEatdApplyChangesToPerson,
  instanceEatdPreviewChangesForPerson,
  instanceEatdCountMatchingPersons,
  instanceEatdTestChangeAdd,
  instanceEatdTestChangeRemove,
  instanceEatdApplyChangesToChange,
  instanceEatdPreviewChangesForChange,
  instanceEatdCountMatchingChanges,
};

export default connect(mapStateToProps, mapDispatchToProps)(EATDTester);

// Define propTypes outside the class
EATDTester.propTypes = {
  // Props passed down from parent (InstanceSetup or InstanceDashboard)
  instance: PropTypes.object.isRequired, // Instance details
  endpointsByType: PropTypes.object.isRequired, // Endpoint map { topdesk: { id: ... } }
  isInstanceLoading: PropTypes.bool.isRequired, // Loading state from parent
  // Props mapped from Redux (eatd.test slice)
  error: PropTypes.object, // General error for EATD test panel
  topdeskOperators: PropTypes.object.isRequired,
  isAddingOperator: PropTypes.bool.isRequired,
  isCountingOperatorMatches: PropTypes.bool.isRequired,
  isAddingIncident: PropTypes.bool.isRequired,
  isAddingPerson: PropTypes.bool.isRequired,
  isAddingChange: PropTypes.bool.isRequired,
  isCountingIncidentMatches: PropTypes.bool.isRequired,
  isCountingPersonMatches: PropTypes.bool.isRequired,
  isCountingChangeMatches: PropTypes.bool.isRequired,
  addIncidentError: PropTypes.object,
  addPersonError: PropTypes.object,
  addChangeError: PropTypes.object,
  operatorMatchCount: PropTypes.number,
  operatorMatchCountError: PropTypes.object,
  incidentMatchCount: PropTypes.number,
  incidentMatchCountError: PropTypes.object,
  personMatchCount: PropTypes.number,
  personMatchCountError: PropTypes.object,
  changeMatchCount: PropTypes.number,
  changeMatchCountError: PropTypes.object,
  testIncidents: PropTypes.object.isRequired,
  testPersons: PropTypes.object.isRequired,
  testChanges: PropTypes.object.isRequired,
  // Actions
  instanceEatdTestOperatorAdd: PropTypes.func.isRequired,
  instanceEatdTestOperatorRemove: PropTypes.func.isRequired,
  instanceEatdAnonymizeOperator: PropTypes.func.isRequired,
  instanceEatdTestPreviewAnonymization: PropTypes.func.isRequired,
  instanceEatdCountMatchingOperators: PropTypes.func.isRequired,
  instanceEatdTestIncidentAdd: PropTypes.func.isRequired,
  instanceEatdTestIncidentRemove: PropTypes.func.isRequired,
  instanceEatdApplyChangesToIncident: PropTypes.func.isRequired,
  instanceEatdPreviewChangesForIncident: PropTypes.func.isRequired,
  instanceEatdCountMatchingIncidents: PropTypes.func.isRequired,
  instanceEatdTestPersonAdd: PropTypes.func.isRequired,
  instanceEatdTestPersonRemove: PropTypes.func.isRequired,
  instanceEatdApplyChangesToPerson: PropTypes.func.isRequired,
  instanceEatdPreviewChangesForPerson: PropTypes.func.isRequired,
  instanceEatdCountMatchingPersons: PropTypes.func.isRequired,
  instanceEatdTestChangeAdd: PropTypes.func.isRequired,
  instanceEatdTestChangeRemove: PropTypes.func.isRequired,
  instanceEatdApplyChangesToChange: PropTypes.func.isRequired,
  instanceEatdPreviewChangesForChange: PropTypes.func.isRequired,
  instanceEatdCountMatchingChanges: PropTypes.func.isRequired,
};